
import SearchBar from '@/components/common/SearchBar'
import { DownOutlined, UpOutlined, SearchOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { computed, onBeforeMount, reactive, ref } from 'vue'

import { getTags, getTeacherTags } from '@/services/common'
import {
  getOfficialSheetSongs,
  deleteOfficialSheetSong,
  getPersonalSheetSongs,
  deletePersonalSheetSong,
  copySheetSong
} from '@/services/songs'
import { debounce } from '@/utils/common'
import { songType } from '@/utils/dataMap/song'
import { useRouter } from 'vue-router'
import { filterPermiison, PermissionMap } from '@/utils/auth'
import SelectBookModal from '../components/SelectBookModal'

export default {
  name: 'List',
  components: {
    SearchBar,
    DownOutlined,
    UpOutlined,
    SearchOutlined,
    SelectBookModal
  },
  setup () {
    const tabList = filterPermiison([
      {
        key: 1,
        title: '官方歌曲'
      },
      {
        key: 2,
        title: '我的歌曲',
        permission: PermissionMap.SHEET_SONGS_PERSONAL_LIST
      }
    ])
    const modalRef = ref()
    const pageData = reactive({
      firstLoading: true,
      advanced: false,
      type: 1,
      tagParams: {
        pageSize: 50,
        page: 1,
        keyword: ''
      },
      modalVisible: false
    })
    const formState = reactive({
      name: '',
      song_type: -1,
      book_section_id: [],
      song_code: '',
      py: '',
      status: 0
    })
    const formOpts = reactive({
      songType: [],
      bookOptions: [],
      bookOpts: {
        showName: '教材名称-章节目录'
      },
      defaultBookOpts: {
        showName: '教材名称-章节目录'
      }
    })

    for (const [k, v] of songType) {
      formOpts.songType.push({ value: k, label: v.name })
    }

    const tableState = reactive({
      data: [],
      columns: [],
      loading: true,
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10,
        showTotal: total => `共${total}条`,
        showQuickJumper: true
      }
    })

    tableState.columns = [
      {
        title: '歌曲名称',
        dataIndex: 'name',
        ellipsis: true,
        width: 200
      },
      {
        title: '歌曲识别码',
        dataIndex: 'song_code',
        width: 140,
        ellipsis: true
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        width: 100,
        ellipsis: true
      },
      {
        title: '歌曲类型',
        dataIndex: 'song_type',
        width: 100,
        slots: { customRender: 'songType' }
      },
      {
        title: '歌曲速度',
        dataIndex: 'speed',
        width: 90
      },
      // {
      //   title: '状态',
      //   dataIndex: 'status',
      //   width: 100
      // },
      {
        title: '标签',
        dataIndex: 'tags',
        width: 200,
        ellipsis: true,
        slots: { customRender: 'tags' }
      },
      {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '修改时间',
        dataIndex: 'updated_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 230,
        slots: { customRender: 'action' }
      }
    ]

    const router = useRouter()

    const getList = debounce(async (params) => {
      const getSheetSong = pageData.type === 1 ? getOfficialSheetSongs : getPersonalSheetSongs
      tableState.loading = true
      params = { ...queryParams.value, page: 1, ...params }
      const { items, pagination } = await getSheetSong(params)
      tableState.data = items
      tableState.loading = false
      tableState.pagination = { ...tableState.pagination, ...pagination }
    })

    const handleTableChange = (pag, filters, sorter) => {
      tableState.pagination = pag
      getList({ page: pag.current })
    }

    const handleReset = () => {
      modalRef.value.handleReset()
      formState.song_type = -1
      formState.song_code = ''
      formState.py = ''
      formState.name = ''
      formState.book_section_id = []
      formState.tag = []
      formState.status = 0
      formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      getTagsOptions()
      getList()
    }

    const queryParams = computed(() => {
      const params = { ...formState }
      if (params.song_type === -1) {
        delete params.song_type
      }
      if (params.song_code === '') {
        delete params.song_code
      }
      if (params.py === '') {
        delete params.py
      }
      if (params.book_section_id.length === 0) {
        delete params.book_section_id
      } else if (params.book_section_id.length === 1) {
        params.book_id = params.book_section_id[0]
        delete params.book_section_id
      } else {
        params.book_id = params.book_section_id[0]
        params.book_section_id = params.book_section_id[params.book_section_id.length - 1]
      }
      for (const key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      params.per_page = tableState.pagination.pageSize
      params.page = tableState.pagination.current
      return params
    })

    const getTagsOptions = debounce(async () => {
      const params = {
        per_page: pageData.tagParams.pageSize,
        current: pageData.tagParams.page,
        keyword: pageData.tagParams.keyword
      }
      const getTagsService = pageData.type === 1 ? getTags : getTeacherTags
      formOpts.tags = (await getTagsService(params)).items.map(i => {
        i.label = i.tag
        i.value = i.tag
        return i
      })
    })

    const handleDelete = async record => {
      const deleteService = pageData.type === 1 ? deleteOfficialSheetSong : deletePersonalSheetSong
      await deleteService(record.id)
      message.success('删除成功')
      getList({ page: tableState.pagination.current })
    }

    const formatCascaderChildrenOpts = (children) => {
      return children.map(i => {
        const item = {
          label: i.name,
          value: i.id
        }
        if (i.children) {
          item.children = formatCascaderChildrenOpts(i.children)
        }
        return item
      })
    }

    const handleCreate = async () => {
      router.push(`/resource/sheet-songs/create/${pageData.type}`)
    }

    const handleTagSearch = v => {
      pageData.tagParams.page = 1
      pageData.tagParams.keyword = v
      getTagsOptions()
    }

    const handleSelectBookSection = (value) => {
      pageData.modalVisible = false
      if (value.values.length > 0) {
        formOpts.bookOpts.showName = value.labels.join('-')
        formState.book_section_id = value.values
      } else {
        formOpts.bookOpts.showName = formOpts.defaultBookOpts.showName
      }
      getList()
    }

    const handleTypeChange = () => {
      getList()
      getTagsOptions()
    }

    const handleCopy = async (record) => {
      const key = 'copy'
      try {
        await copySheetSong(record.id)
        message.loading({
          key,
          content: '正在处理'
        })
        message.success({
          key,
          content: '复制成功'
        })
      } catch (e) {
        message.error({
          key,
          content: '操作失败'
        })
      }
    }

    onBeforeMount(async () => {
      await Promise.all([
        getList(),
        getTagsOptions()
      ])
      pageData.firstLoading = false
    })

    return {
      tabList,
      modalRef,
      songType,
      pageData,
      formState,
      formOpts,
      tableState,
      getList,
      PermissionMap,
      handleTableChange,
      handleDelete,
      handleCreate,
      handleReset,
      handleTagSearch,
      handleSelectBookSection,
      handleTypeChange,
      handleCopy
    }
  }
}
